
/**
 * Convert a date into a datetime string.
 *
 * @param {Date} date Date object
 */
export function convertDate (date) {
    const year = `0000${date.getFullYear()}`.slice(-4)
    const month = `00${date.getMonth() + 1}`.slice(-2)
    const day = `00${date.getDate()}`.slice(-2)
    const hour = `00${date.getHours()}`.slice(-2)
    const minute = `00${date.getMinutes()}`.slice(-2)
    const second = `00${date.getSeconds()}`.slice(-2)

    return `${year}-${month}-${day} ${hour}:${minute}:${second}`
}

/**
 * Convert an JS object into a URLSearchParam object.
 *
 * @param {object} data Key/value pair of parameters
 * @param {object} options Key/value pair of options
 *
 * @return {URLSearchParams}
 */
export function objectToParams (data, options) {
    const params = new URLSearchParams()
    const settings = options || {}

    for (const key in data) {
        if (data.hasOwnProperty(key)) {
            const value = data[key]

            // do nothing if we want to ignore the key
            if (settings.ignore && settings.ignore.includes(key)) {
                continue
            }

            if ((settings.dontConvertDate !== true) && value instanceof Date) {
                params.append(key, convertDate(value))
            } else {
                params.append(key, value)
            }
        }
    }

    return params
}



// WEBPACK FOOTER //
// ./src/utilities/form-data.js